import * as Sentry from '@sentry/react';
import { ToastProvider } from '@octano/global-ui';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './assets/scss/styles.scss';
import './config/date';
import './config/language';
import UserProvider from './providers/UserProvider';
import { UserStateProviderLoader } from './providers/UserStateProviderLoader';
import reportWebVitals from './reportWebVitals';
import { getJWT, parseJWT, removeJWT, setJWT } from './utils/auth';

const SSO_HASH_PREFIX = '#access_token=';
const ssoHash = window.location.hash;
if (ssoHash.startsWith(SSO_HASH_PREFIX)) {
  const token = decodeURIComponent(ssoHash.slice(SSO_HASH_PREFIX.length));
  if (token) {
    setJWT(token);
    localStorage.setItem('authProvider', 'microsoft-entra-id');
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search,
    );
  }
}

const existingJwt = getJWT();
if (existingJwt) {
  try {
    const payload = parseJWT(existingJwt);
    const nowSeconds = Math.floor(Date.now() / 1000);
    if (typeof payload?.exp === 'number' && payload.exp <= nowSeconds) {
      removeJWT();
    }
  } catch {
    removeJWT();
  }
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_COMMIT_ID ?? 'unknown',
    tracesSampleRate: 0.1,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Ha ocurrido un error.</p>}>
      <ToastProvider>
        <UserStateProviderLoader>
          {(userData) => (
            <UserProvider user={userData}>
              <App />
            </UserProvider>
          )}
        </UserStateProviderLoader>
      </ToastProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
